import { NOTE_LEVEL_LABELS } from '@/lib/note-format';
import type { NoteVisibility } from '@mss_creator/shared';
import { Badge, type BadgeTone } from '@pms-digital/design-system';

/** The icon of each level: the company (Client), the team (Équipe PMS), a padlock (Privée). */
export const NOTE_LEVEL_ICONS: Record<NoteVisibility, string> = {
  client: 'apartment',
  pms: 'group',
  private: 'lock',
};

const LEVEL_TONES: Record<NoteVisibility, BadgeTone> = {
  client: 'info',
  pms: 'accent',
  private: 'neutral',
};

export interface NoteLevelBadgeProps {
  visibility: NoteVisibility;
  className?: string;
}

/**
 * The level of a note as a badge of the design system: Client in the info
 * tone, Équipe PMS in the accent tone, Privée in neutral with a padlock
 * (planche 09).
 */
export function NoteLevelBadge({ visibility, className }: NoteLevelBadgeProps) {
  const badge = (
    <Badge tone={LEVEL_TONES[visibility]} icon={NOTE_LEVEL_ICONS[visibility]} maxWidth="none">
      {NOTE_LEVEL_LABELS[visibility]}
    </Badge>
  );
  return className ? <span className={className}>{badge}</span> : badge;
}
